export enum CommonQueryKey {
  AppLocaleCache = 'common/appLocaleCache',
}
